module.exports = __webpack_public_path__ + "static/media/giphy-4.f3a8b0b2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-4.gif
// module id = 175
// module chunks = 0